import React from 'react'

import Selector from './Selector'

const SitesSelector = () => {
  return <Selector />
}

export default SitesSelector
